import { CALL_API, Schemas } from '../../common/middleware/api';

export const CENTERS_BY_FRANCHISEE_REQUEST = 'CENTERS_BY_FRANCHISEE_REQUEST';
export const CENTERS_BY_FRANCHISEE_SUCCESS = 'CENTERS_BY_FRANCHISEE_SUCCESS';
export const CENTERS_BY_FRANCHISEE_FAILURE = 'CENTERS_BY_FRANCHISEE_FAILURE';

export const CENTERS_REQUEST = 'CENTERS_REQUEST';
export const CENTERS_SUCCESS = 'CENTERS_SUCCESS';
export const CENTERS_FAILURE = 'CENTERS_FAILURE';

export const CENTERS_UNPAGED_REQUEST = 'CENTERS_UNPAGED_REQUEST';
export const CENTERS_UNPAGED_SUCCESS = 'CENTERS_UNPAGED_SUCCESS';
export const CENTERS_UNPAGED_FAILURE = 'CENTERS_UNPAGED_FAILURE';

export const CENTER_FETCH_REQUEST = 'CENTER_GET_REQUEST';
export const CENTER_FETCH_SUCCESS = 'CENTER_GET_SUCCESS';
export const CENTER_FETCH_FAILURE = 'CENTER_GET_FAILURE';

export const CENTER_CREATE_REQUEST = 'CENTER_CREATE_REQUEST';
export const CENTER_CREATE_SUCCESS = 'CENTER_CREATE_SUCCESS';
export const CENTER_CREATE_FAILURE = 'CENTER_CREATE_FAILURE';

export const CENTER_UPDATE_REQUEST = 'CENTER_UPDATE_REQUEST';
export const CENTER_UPDATE_SUCCESS = 'CENTER_UPDATE_SUCCESS';
export const CENTER_UPDATE_FAILURE = 'CENTER_UPDATE_FAILURE';

export const loadCentersByFranchisee = ({ franchiseeId, ...options }) => ({
	[CALL_API]: {
		types: [CENTERS_BY_FRANCHISEE_REQUEST, CENTERS_BY_FRANCHISEE_SUCCESS, CENTERS_BY_FRANCHISEE_FAILURE],
		endpoint: 'api/centers',
		request: { franchiseeId, ...options },
		schema: Schemas.CENTER_ARRAY
	},
	franchiseeId
});

export const loadCenters = (options) => ({
	[CALL_API]: {
		types: [CENTERS_REQUEST, CENTERS_SUCCESS, CENTERS_FAILURE],
		endpoint: 'api/centers',
		request: options,
		schema: Schemas.CENTER_ARRAY
	}
});

export const loadUnpagedCenters = (options) => ({
	[CALL_API]: {
		types: [CENTERS_UNPAGED_REQUEST, CENTERS_UNPAGED_SUCCESS, CENTERS_UNPAGED_FAILURE],
		endpoint: 'api/centers/unpaged',
		request: options,
		schema: Schemas.CENTER_ARRAY
	}
});

export const fetchCenter = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CENTER_FETCH_REQUEST, CENTER_FETCH_SUCCESS, CENTER_FETCH_FAILURE],
		endpoint: `api/centers/${id}`,
		schema: Schemas.CENTER,
		onSuccessEvent
	}
});

export const createCenter = (center, history) => ({
	[CALL_API]: {
		types: [CENTER_CREATE_REQUEST, CENTER_CREATE_SUCCESS, CENTER_CREATE_FAILURE],
		endpoint: 'api/centers',
		method: 'POST',
		request: center,
		schema: Schemas.CENTER,
		form: 'center',
		transition: {
			history,
			successPath: (response) => {
				const { id, franchiseeId } = response.entities.centers[response.result];
				return `/franchisees/${franchiseeId}/centers/${id}`;
			}
		}
	}
});

export const updateCenter = (id, center) => ({
	[CALL_API]: {
		types: [CENTER_UPDATE_REQUEST, CENTER_UPDATE_SUCCESS, CENTER_UPDATE_FAILURE],
		endpoint: `api/centers/${id}`,
		method: 'PUT',
		request: center,
		schema: Schemas.CENTER,
		form: 'center'
	}
});